import Grid from "@mui/material/Grid2";
import { Box, Typography } from "@mui/material";
import { isEmpty } from "lodash";

import { TabSessionDataReAuthResponse } from "../../../../models/api/TabSessionStorage";
import { flexColumn, flexRow } from "../../../../styles/mui/styles/display";
import ReadOnlyField from "../../../../components/FormPriorAuthReAuth/ReadOnlyField";
import { getValue } from "../../../../utils";
import { FieldSpacing } from "../../../PriorAuthWorkFlow/styles/style";
import { DisciplineTableHeader } from "../../../../constants/Referral";
import { formatDate } from "../../../../utils/DateTime";
import { DateFormats } from "../../../../constants/Date";
import fontWeight from "../../../../styles/mui/fontWeight";
import { fontSize } from "../../../../styles/mui/styles/font";
import colors from "../../../../styles/colors/colors";
import { FlexRow } from "../../../CreatePriorAuth/style/style";
import { requestReview, verticleDivider } from "../../styles/style";
import { accordionHeaderText } from "../../../PriorAuthWorkFlow/styles/Review";
import { TypographyBox } from "../../../../app/common/TextLabel";
import { MemberInfoData } from "../../../../models/Patient";

export interface PropsFromState {
  tabSessionStorage: TabSessionDataReAuthResponse;
  memberInfoDataState: MemberInfoData;
}

type AllProps = PropsFromState;

const RequestService: React.FC<AllProps> = ({
  tabSessionStorage,
  memberInfoDataState,
}) => {
  const getVisits = (
    discipline: string,
    visitType: "currentVisit" | "nextVisit",
    label: string
  ) => {
    if (
      !isEmpty(
        getValue(tabSessionStorage, "response.requestService.disciplines")
      ) &&
      getValue(tabSessionStorage, "response.requestService.disciplines")
        .length > 0
    ) {
      const visit =
        tabSessionStorage.response.requestService.disciplines
          .filter((item) => item.discipline === discipline)
          .map((disc) => disc[visitType])[0] || 0;
      return (
        <Grid sx={FlexRow} alignItems="left" spacing={2} pb={3}>
          <Grid size={{ xs: 10 }}>
            <Typography
              fontWeight={fontWeight[3]}
              fontSize={fontSize[12]}
              color={colors.fonts[2]}
            >
              {label} :
            </Typography>
          </Grid>
          <Grid size={{ xs: 6 }}>
            <Typography
              fontWeight={fontWeight[4]}
              fontSize={fontSize[12]}
              color={colors.fonts[2]}
            >
              {visit}
            </Typography>
          </Grid>
        </Grid>
      );
    }
    return <></>;
  };
  return (
    <Grid container sx={flexRow}>
      <Grid size={{ xs: 4 }}>
        <Grid size={{ xs: 12 }} sx={FieldSpacing}>
          <ReadOnlyField
            label={"Start of Care:"}
            value={formatDate(
              getValue(
                tabSessionStorage,
                "response.requestService.startOfCare"
              ),
              DateFormats.MM_DD_YYYY,
              DateFormats.YYYY_MM_DD,
              true
            )}
          />
        </Grid>
        <Grid size={{ xs: 12 }} sx={FieldSpacing}>
          <Typography
            pb={2}
            fontWeight={fontWeight[3]}
            fontSize={fontSize[12]}
            color={colors.fonts[2]}
          >
            {DisciplineTableHeader.MEMBER_ADMITTED} : &nbsp;
            {getValue(
              tabSessionStorage,
              "response.requestService.memberAdmitted"
            )}
          </Typography>
          {savedDetails(
            "Inpatient Admit Date",
            formatDate(
              getValue(
                tabSessionStorage,
                "response.requestService.inpatientAdmitDate"
              ),
              DateFormats.MM_DD_YYYY
            )
          )}
          {savedDetails(
            "Inpatient Discharge Date",
            formatDate(
              getValue(
                tabSessionStorage,
                "response.requestService.inpatientDischargeDate"
              ),
              DateFormats.MM_DD_YYYY
            )
          )}
        </Grid>
        <Grid size={{ xs: 12 }} sx={FieldSpacing}>
          <Typography
            pb={2}
            fontWeight={fontWeight[3]}
            fontSize={fontSize[12]}
            color={colors.fonts[2]}
          >
            {DisciplineTableHeader.MEMBER_EMERGENCY} : &nbsp;
            {getValue(tabSessionStorage, "response.requestService.memberVisit")}
          </Typography>
          {savedDetails(
            "Emergency Visit Date",
            formatDate(
              getValue(tabSessionStorage, "response.requestService.visitDate"),
              DateFormats.MM_DD_YYYY
            )
          )}
        </Grid>
      </Grid>
      <Grid>
        <Grid sx={verticleDivider} />
      </Grid>
      <Box sx={accordionHeaderText}>
        {TypographyBox("Visits :", colors.black[2], fontWeight[4])}
      </Box>
      <Grid sx={requestReview} pt={4} pl={2}>
        <Grid size={{ xs: 6 }} sx={flexColumn}>
          {getVisits("SN", "currentVisit", "Current SN Visits")}
          {getVisits("PT", "currentVisit", "Current PT Visits")}
          {getVisits("OT", "currentVisit", "Current OT Visits")}
          {getVisits("ST", "currentVisit", "Current ST Visits")}
          {getVisits("MSW", "currentVisit", "Current MSW Visits")}
          {getVisits("HHA", "currentVisit", "Current HHA Visits")}
        </Grid>
        {memberInfoDataState && !memberInfoDataState.isIngest && (
          <Grid size={{ xs: 6 }} sx={flexColumn}>
            {getVisits("SN", "nextVisit", "Next SN Visits")}
            {getVisits("PT", "nextVisit", "Next PT Visits")}
            {getVisits("OT", "nextVisit", "Next OT Visits")}
            {getVisits("ST", "nextVisit", "Next ST Visits")}
            {getVisits("MSW", "nextVisit", "Next MSW Visits")}

            {getVisits("HHA", "nextVisit", "Next HHA Visits")}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default RequestService;

export const savedDetails = (label: string, value: string) => {
  return (
    <Grid container justifyContent="left" pb={2}>
      <Typography
        fontWeight={fontWeight[3]}
        fontSize={fontSize[12]}
        color={colors.fonts[2]}
      >
        {label} :
      </Typography>
      <Typography
        fontWeight={fontWeight[4]}
        fontSize={fontSize[13]}
        lineHeight="1.3"
        pl={2}
      >
        {value}
      </Typography>
    </Grid>
  );
};
